import React from 'react';
import type { ChecklistPayload } from '../../../data-access/api/science/openapi/api';
import './richContext.scss';

type Props = {
  p: ChecklistPayload;
};

const ChecklistContent: React.FC<Props> = ({ p }) => {
  return (
    <div className="rc-content-body">
      {!!p.label && <span className="rc-content-label">{p.label}</span>}
      {p.items.map((item, i) => (
        <div key={i} className="rc-list-row">
          <span className={`rc-list-bullet${item.done ? ' rc-list-bullet--done' : ''}`}>
            {item.done ? '✓' : '○'}
          </span>
          <span className={`rc-list-text${item.done ? ' rc-list-text--done' : ''}`}>
            {item.text}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ChecklistContent;
